import React from "react";
import { Icons } from "@texada/ui";
import TexadaFullLogo from "../../../../public/img/TexadaLogo";
import TexadaChevronLogo from "../../../../public/img/TexadaChevron";

const TexadaLogo = props => {
  const logo = props.isNavOpen ? (
    <TexadaFullLogo className="texada-logo" />
  ) : (
    <TexadaChevronLogo className="texada-chevron" />
  );

  return props.isMobile ? (
    <div className="side_nav_icon">
      <span className="side_nav_close-icon">
        <Icons.Close />
      </span>
      {logo}
    </div>
  ) : (
    <div className="side_nav_icon reg">{logo}</div>
  );
};

export default TexadaLogo;
